import React from 'react';
import { translate } from 'react-i18next';

const layerContainerStyle = {
  display: 'flex',
  flexFlow: 'column',
  width: '100%',
  height: '50%',
  bottom: 0,
  position: 'absolute',
  border: 'solid 2px',
};

const annotateContainerStyle = {
  display: 'flex',
  width: '100%',
  height: '100%',
  position: 'absolute',
  justifyContent: 'space-around',
};

class MaterialLayerPreviewerHorizontal extends React.Component {
  constructor(props) {
    super(props);

    this.colorHash = {};
  }

  computeParams() {
    return {
      materials: this.props.materials,
      offsetThickness: this.props.materials.reduce((offsetThicknessList, material) => {
        const lastThickness = offsetThicknessList.length > 0 ? offsetThicknessList[offsetThicknessList.length - 1] : 0;
        return [...offsetThicknessList, lastThickness + material.thickness];
      }, []),
      totalThickness: this.props.materials.reduce((accum, material) => accum + material.thickness, 0),
    };
  }

  getColor(id) {
    const keys = Object.keys(this.colorHash);
    if (keys.indexOf(String(id)) === -1) {
      this.colorHash[id] = keys.length;
    }

    const palette = [
      '#cec24c',
      '#8b7b61',
      '#a77e55',
      '#d0cec9',
      '#6d7b9f',
    ];
    return palette[this.colorHash[id] % palette.length];
  }

  renderLayer(id, name, thickness, totalThickness, color) {
    const ratio = thickness / totalThickness;
    return (
      <div
        key={`layer_${id}`}
        style={{ flex: ratio, backgroundColor: color }}
      />
    );
  }

  renderAnnotation(name, thickness, totalThickness, offsetThickness, layerCount) {
    const { unit } = this.props;
    const width = layerCount * 2;
    const thicknessRadio = (thickness / totalThickness) * layerCount;
    const offsetRatio = (offsetThickness / totalThickness) * layerCount;
    const arrowOffset = offsetRatio - thicknessRadio * 0.5;
    return (
      <div style={{ display: 'flex', justifyContent: 'center', flexFlow: 'column', flex: 1 }}>
        <div style={{ flex: width - arrowOffset, display: 'flex', flexFlow: 'column'}}>
          <div>
            <span style={{ fontSize: '20px' }}>{name} {thickness} {unit}</span>
          </div>
          <div style={{ backgroundColor: 'red', width: 2, flex: 1, alignSelf: 'center', marginRight: 4 }} />
          <div style={{ backgroundColor: 'red', width: '8px', height: '8px', borderRadius:'5px', alignSelf: 'center', marginLeft: -5 }}/>
        </div>
        <div style={{ flex: arrowOffset }} />
      </div>
    );
  }

  render() {
    const { materials, totalThickness, offsetThickness } = this.computeParams();
    return (
      <div style={{ marginTop: 10, marginBottom: 10, height: 500, position: 'relative' }}>
        <div style={layerContainerStyle}>
          {materials.reverse().map(({ id, name, thickness, material_id }, index) => this.renderLayer(id, name, thickness, totalThickness, this.getColor(material_id)))}
        </div>
        <div style={annotateContainerStyle}>
          {materials.reverse().map(({ name, thickness }, index) => this.renderAnnotation(name, thickness, totalThickness, offsetThickness[index], materials.length))}
        </div>
      </div>
    );
  }
}

export default translate('translations')(MaterialLayerPreviewerHorizontal);



// WEBPACK FOOTER //
// ./src/components/material/MaterialLayerPreviewerHorizontal.js